import React from "react";
import LoadingRow from "./LoadingRow";
import CopyableContainer from "./CopyableContainer";
import LeagueTabHeading from "./LeagueTabHeading";
import "./styles/tableStyles.css";

const getRowClassName = (team, index) => {
    const baseClassName = index % 2 === 0 ? "even-row" : "odd-row";
    if (team.isByeTeam) {
        return `${baseClassName} standings-row-bye`;
    }
    if (team.isPlayoffTeam) {
        return `${baseClassName} standings-row-playoff`;
    }
    return baseClassName;
};

const StandingsTable = ({ data, week, loading }) => {
    const playoffTeamCount = Array.isArray(data)
        ? data.filter((team) => team.isPlayoffTeam).length
        : 0;
    const byeTeamCount = Array.isArray(data)
        ? data.filter((team) => team.isByeTeam).length
        : 0;

    return (
        <CopyableContainer
            title={
                <LeagueTabHeading
                    eyebrow="Standings"
                    title={`Through Week ${week}`}
                    className="mb-0"
                />
            }
            fileName={`standings-week-${week}`}
        >
            <>
                <div className="table-rounded-shell">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Owner</th>
                                <th>Wins</th>
                                <th>Losses</th>
                                <th>Ties</th>
                                <th>Points For</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading || !data ? (
                                <LoadingRow text="Loading Standings..." colSpan="5" />
                            ) : data.length === 0 ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No standings available.
                                    </td>
                                </tr>
                            ) : (
                                data.map((team, index) => (
                                    <tr
                                        key={index}
                                        className={getRowClassName(team, index)}
                                    >
                                        <td className="team-name-column standings-team-cell">
                                            <div className="standings-team-content">
                                                <span className="team-identity-primary">
                                                    {team.owner || team.team}
                                                </span>
                                                {team.owner && team.team ? (
                                                    <span className="team-identity-secondary">
                                                        {team.team}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </td>
                                        <td>{team.wins}</td>
                                        <td>{team.losses}</td>
                                        <td>{team.ties}</td>
                                        <td>{team.pointsFor}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                {!loading && Array.isArray(data) && data.length > 0 && (
                    <div className="standings-summary">
                        <div className="standings-status-badges">
                            {byeTeamCount > 0 && (
                                <span className="standings-status-badge standings-status-badge-bye">
                                    Bye
                                </span>
                            )}
                            {playoffTeamCount > 0 && (
                                <span className="standings-status-badge standings-status-badge-playoff">
                                    Playoff
                                </span>
                            )}
                        </div>
                        <p className="standings-summary-note">
                            {playoffTeamCount} team
                            {playoffTeamCount === 1 ? "" : "s"} make the playoffs
                            {byeTeamCount > 0
                                ? `, with ${byeTeamCount} ${byeTeamCount === 1 ? "team" : "teams"
                                } getting a bye.`
                                : "."}
                        </p>
                    </div>
                )}
            </>
        </CopyableContainer>
    );
};

export default StandingsTable;
